<template>
    <div class="row left-content">
        <b-card
            title="Create project"
        >
            <b-form @submit.prevent.stop="create">
                <b-form-group label="Email address">
                    <b-form-input
                        type="email"
                        v-model="form.email"
                        required>
                    </b-form-input>
                </b-form-group>
                <b-form-group label="First name">
                    <b-form-input
                        type="text"
                        v-model="form.first_name"
                        required>
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Last name">
                    <b-form-input
                        type="text"
                        v-model="form.last_name"
                        required>
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Password">
                    <b-form-input
                        type="password"
                        v-model="form.password"
                        required>
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Base URL">
                    <b-form-input
                        type="text"
                        v-model="form.base_url"
                        required>
                    </b-form-input>
                </b-form-group>
                <b-form-group>
                    <b-form-checkbox v-model="form.is_test_mode" name="check-button" switch>
                        Is Test mode
                    </b-form-checkbox>
                </b-form-group>
                <b-form-group label="Payment URL">
                    <b-form-input
                        type="text"
                        v-model="form.payment_url"
                    >
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Transfer URL">
                    <b-form-input
                        type="text"
                        v-model="form.transfer_url"
                    >
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Balance URL">
                    <b-form-input
                        type="text"
                        v-model="form.balance_url"
                    >
                    </b-form-input>
                </b-form-group>
                <b-button type="submit" variant="primary">Create</b-button>
                <div class="invalid-feedback d-block" v-for="error in server_errors" :key="error">{{ error }}</div>
            </b-form>
        </b-card>
    </div>
</template>

<script>

import {ServerErrors} from "@/mixins/ServerErrors";
import Swal from "sweetalert2";

export default {
    name: "Create",
    data() {
        return {
            form: {
                email: null,
                first_name: null,
                last_name: null,
                base_url: null,
                payment_url: null,
                transfer_url: null,
                balance_url: null,
                is_test_mode: false
            }
        }
    },
    mixins: [ServerErrors],
    computed: {
    },
    methods: {
        create() {
            let loader = this.$loading.show();
            window.axios({
                method: 'POST',
                url: '/admin/dev/project/create',
                data: this.form
            })
                .then(() => {
                    this.$router.push({ name: 'admin.projects' });
                })
                .catch(error => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data.title ? error.response.data.title: "Something went wrong."
                    });
                })
                .finally(() => {
                    loader.hide();
                });
        }
    },
    mounted() {
    }
}
</script>